import { render } from "./DocumentHandle.vue?vue&type=template&id=0d14825e&scoped=true"
import script from "./DocumentHandle.vue?vue&type=script&lang=js"
export * from "./DocumentHandle.vue?vue&type=script&lang=js"

import "./DocumentHandle.vue?vue&type=style&index=0&id=0d14825e&lang=sass&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d14825e"]])

export default __exports__